import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Form, Input, Button, Card, Typography, Alert } from 'antd';
import { UserOutlined, LockOutlined, ClusterOutlined } from '@ant-design/icons';

import { useAuth } from '../../authentication/AuthProvider';
import request from '../../lib/request';
import { APP_VERSION } from '../../lib/version';

export default function LoginPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    document.title = 'Sign in - InstantRead PMS';
  }, []);

  // Already signed in (e.g. the page was refreshed): go straight back to where the user was.
  React.useEffect(() => {
    if (auth.user) navigate(location.state?.from?.pathname || '/', { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.user]);

  const onFinish = (values) => {
    setLoading(true);
    setError(null);

    request
      .post('/auth/login', values)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          auth.signIn(response.data);
          const from = response.data.mustChangePassword ? '/account?required=1' : location.state?.from?.pathname || '/';
          navigate(from, { replace: true });
        } else {
          setError(response.message);
        }
      })
      .catch(() => setError('Could not reach the server. Please try again.'))
      .finally(() => setLoading(false));
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f4f5f6',
      }}
    >
      <Card style={{ width: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: 20 }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 48, height: 48, borderRadius: 12, background: '#2f54eb', color: '#fff', fontSize: 24, marginBottom: 12 }}>
            <ClusterOutlined />
          </div>
          <Typography.Title level={3} style={{ marginBottom: 2 }}>
            InstantRead PMS
          </Typography.Title>
          <Typography.Text type="secondary">Practice management for accounting firms</Typography.Text>
        </div>

        {error && <Alert type="error" message={error} showIcon style={{ marginBottom: 16 }} />}

        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item name="email" rules={[{ required: true, message: 'Please enter your email' }]}>
            <Input prefix={<UserOutlined />} placeholder="Email" size="large" autoComplete="username" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: 'Please enter your password' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="Password" size="large" autoComplete="current-password" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block size="large" loading={loading}>
              Sign In
            </Button>
          </Form.Item>
        </Form>
        <Typography.Text type="secondary" style={{ display: 'block', textAlign: 'center', fontSize: 12 }}>
          Forgotten your password? Ask your administrator to reset it. &middot; v{APP_VERSION}
        </Typography.Text>
      </Card>
    </div>
  );
}
